import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Aktualizováno:',
  breadcrumbs: {
    home: 'Domovskou stránku',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Proč nám můžete věřit',
        details: {
          text: '<h2>Proč nám můžete věřit</h2><p>Články na Natu.Care jsou psány na základě vědeckého výzkumu, údajů z vládních webových stránek a dalších spolehlivých zdrojů. Texty jsou psány ve spolupráci s lékaři, odborníky na výživu a dalšími odborníky na zdraví a krásu. Články jsou před zveřejněním a při významných aktualizacích revidovány.</p>',
          footerText: '<p>Více informací najdete v naší <a href="/cz/o-nas/redakcni-proces">redakční proces</a></p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informace o reklamě',
        details: {
          text: '<h2>Informace o reklamě</h2><p>Obsah stránek Natu.Care může obsahovat odkazy na produkty, z jejichž prodeje můžeme získat provizi. Při tvorbě obsahu dodržujeme vysoké redakční standardy a dbáme na objektivitu ohledně produktů, o kterých hovoříme. Přítomnost partnerských odkazů není diktována našimi partnery a produkty, které recenzujeme, si vybíráme zcela nezávisle sami.</p>',
          footerText: '<p>Více informací najdete v naší <a href="/cz/pravidla">předpisy</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Ověřeno odborníkem',
      footerText: '<p>Zjistěte více o našich <a href="/cz/o-nas/redakcni-proces">redakcni proces</a></p>'
    }
  },

  mediabar: {
    heading: 'Média o nás:',
    href: '/cz/o-nas',
    title: 'O nás',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Zajistěte si zdravé tělo',
    description: 'Vyzkoušejte vysoce kvalitní doplňky stravy Natu.Care',
    button: {label: 'Zobrazit produkty', href: 'https://natu.shop/collections'},
    picture: {alt: 'Mladé, krásné ženy s dobrou kondicí pleti.'}
  },

  authorship: {
    heading: 'Redakce',
    link: {
      label: 'Seznamte se s týmem',
      href: '/cz/o-nas/redakce'
    }
  },

  similarArticles: {
    headingBlogList: 'Články',
    headingBlogPost: 'Podobné články'
  }
};